import { render, staticRenderFns } from "./nav-tab.vue?vue&type=template&id=36a8a95e"
import script from "./nav-tab.vue?vue&type=script&lang=js"
export * from "./nav-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports